
import React from 'react';
import { Event } from '@/lib/types';
import EventCard from '@/components/EventCard';
import { Button } from '@/components/ui/button';
import { Eye, Edit } from 'lucide-react';

interface EventsGridProps {
  events: Event[];
  onViewDetails: (event: Event) => void;
  onEditEvent: (event: Event) => void;
}

const EventsGrid = ({ events, onViewDetails, onEditEvent }: EventsGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {events.map(event => (
        <div key={event.id} className="relative group">
          <EventCard event={event} variant="default" />
          {/* Move buttons to bottom right corner instead of top right */}
          <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex gap-2">
            <Button 
              variant="secondary" 
              size="icon"
              onClick={(e) => {
                e.stopPropagation();
                onViewDetails(event);
              }}
              className="bg-white shadow-md hover:bg-gray-100"
            >
              <Eye className="h-4 w-4" />
            </Button>
            <Button 
              variant="secondary" 
              size="icon"
              onClick={(e) => {
                e.stopPropagation();
                onEditEvent(event);
              }}
              className="bg-white shadow-md hover:bg-gray-100"
            >
              <Edit className="h-4 w-4" />
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EventsGrid;
